export class LegendController {
  constructor(className, map) {
    this._map = map;
    this._wrap = document.querySelector(`.${className}`);

    // Events
    this._eventsElem = this._wrap.querySelector('.today-events');
    this._eventsChild = this._eventsElem.querySelector('a');
    this._eventsChild.addEventListener('click', this.eventsClick.bind(this));

    // HeatMap
    this._heatMapElem = this._wrap.querySelector('.today-heatmap');
    this._heatMapChild = this._heatMapElem.querySelector('a');
    this._heatMapChild.addEventListener('click', this.heatMapClick.bind(this));

    // Bans
    this._bansElem = this._wrap.querySelector('.today-ban');
    this._bansChild = this._bansElem.querySelector('a');
    this._bansChild.addEventListener('click', this.bansClick.bind(this));

    // Crash
    this._crashElem = this._wrap.querySelector('.today-crash');
    this._crashChild = this._crashElem.querySelector('a');
    this._crashChild.addEventListener('click', this.crashClick.bind(this));

    // No tag
    // this._noTagElem = this._wrap.querySelector('.today-tag');
    // this._noTagChild = this._noTagElem.querySelector('a');
    // this._noTagChild.addEventListener('click', this.noTag.bind(this));

    // this.init();
  }

  init() {
    // this._map.linkVehicles(); // FIXME: hard code link

    this.eventsClick();
    this.heatMapClick();
  }

  eventsClick(evt) {
    if(evt) { evt.preventDefault(); }
    const hasClass = this._eventsElem.classList.contains('active');
    if(!hasClass) {
      this._map.linkEvents();
    } else {
      this._map.unlinkEvents();
    }

    // Force heatmap to hide
    if(hasClass && this._heatMapElem.classList.contains('active')) { this.heatMapClick(); }

    this._eventsElem.classList.toggle('active');
  }

  heatMapClick(evt) {
    if(evt) { evt.preventDefault(); }
    const hasClass = this._heatMapElem.classList.contains('active');
    this._map.heatMap = !hasClass;

    // Force event to show
    if(!hasClass && !this._eventsElem.classList.contains('active')) { this.eventsClick(); }

    this._heatMapElem.classList.toggle('active');
  }

  bansClick(evt) {
    if(evt) { evt.preventDefault(); }
    const hasClass = this._bansElem.classList.contains('active');

    if(!hasClass) {
      this._map.linkBans();
    } else {
      this._map.unlinkBans();
    }

    this._map.showBan = !hasClass;

    this._bansElem.classList.toggle('active');
  }

  crashClick(evt) {
    if(evt) { evt.preventDefault(); }
    const hasClass = this._crashElem.classList.contains('active');
    this._map.showCrush = !hasClass;
    this._crashElem.classList.toggle('active');
    this.dimClass();
  }

  noTag(evt) {
    if(evt) { evt.preventDefault(); }
    const hasClass = this._noTagElem.classList.contains('active');
    this._map.noTag = !hasClass;
    this._noTagElem.classList.toggle('active');
    this.dimClass();
  }

  dimClass() {
    if(this._map.noTag || this._map.showCrush) {
      this._wrap.classList.add('dim');
    } else {
      this._wrap.classList.remove('dim');
    }

  }

}
